var translations = {
    de: {
        postalCodeLabel: 'Postleitzahl',
        cityLabel: 'Ort',
    },
};
export default translations;
